import * as React from "react";
const SchoolIcon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={25}
    fill="none"
    {...props}
  >
    <path
      fill="#fff"
      d="M11.95.39a.526.526 0 0 0-.354.2.662.662 0 0 0-.141.416V5.63l-4.713 4.432a.613.613 0 0 0-.147.216.683.683 0 0 0-.05.265V23.16H1.091v-6.952l4.005-3.387a.526.526 0 0 0 .197-.113.605.605 0 0 0 .14-.192.675.675 0 0 0-.076-.7.554.554 0 0 0-.178-.147.495.495 0 0 0-.432-.012L.375 15.19a.555.555 0 0 0-.272.225.67.67 0 0 0-.103.362v8c0 .163.057.32.16.434.102.116.24.18.385.18h22.91a.516.516 0 0 0 .385-.18.657.657 0 0 0 .16-.435v-8a.67.67 0 0 0-.103-.361.555.555 0 0 0-.272-.225l-4.369-3.532a.491.491 0 0 0-.431.012.554.554 0 0 0-.178.147.636.636 0 0 0-.111.215.689.689 0 0 0 .034.485c.035.074.083.14.141.192.058.052.125.09.196.113l4.006 3.387v6.952h-5.458V10.545a.684.684 0 0 0-.05-.265.612.612 0 0 0-.147-.215l-4.713-4.433v-1.55h3.273a.516.516 0 0 0 .385-.18.657.657 0 0 0 .16-.434V1.006a.657.657 0 0 0-.16-.435.516.516 0 0 0-.385-.18h-3.869Zm.595 1.231h2.73v1.23h-2.73v-1.23ZM12 6.726l4.364 4.106v12.325h-2.182v-6.459a.658.658 0 0 0-.16-.435.516.516 0 0 0-.385-.18h-3.324a.526.526 0 0 0-.353.2.661.661 0 0 0-.141.415v6.462H7.637V10.835L12 6.726Zm-1.364 4.429h2.728v1.23h-2.728v-1.23Zm.273 6.154h2.182v5.85H10.91v-5.85Zm-6.002 1.236v1.23h-2.18v-1.23m16.364 0h2.183v1.23H19.09v-1.23Z"
    />
  </svg>
);
export default SchoolIcon;
